import { render, staticRenderFns } from "./CenterBottom.vue?vue&type=template&id=5576ce57&"
import script from "./CenterBottom.vue?vue&type=script&lang=js&"
export * from "./CenterBottom.vue?vue&type=script&lang=js&"
import style0 from "./CenterBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports